import { useState } from 'react';

export const useOnce = (callback: () => void): void => {
  useState(callback);
};
